import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/window-close': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h416zM464 426v-340c0-3.3-2.7-6-6-6h-404c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h404c3.3 0 6-2.7 6-6zM356.5 194.6l-61.4 61.4 61.4 61.4c4.6 4.6 4.6 12.1 0 16.8l-22.3 22.3c-4.6 4.6-12.1 4.6-16.8 0l-61.4-61.4-61.4 61.4c-4.6 4.6-12.1 4.6-16.8 0l-22.3-22.3c-4.6-4.6-4.6-12.1 0-16.8l61.4-61.4-61.4-61.4c-4.6-4.6-4.6-12.1 0-16.8l22.3-22.3c4.6-4.6 12.1-4.6 16.8 0l61.4 61.4 61.4-61.4c4.6-4.6 12.1-4.6 16.8 0l22.3 22.3c4.7 4.6 4.7 12.1 0 16.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/window-close.js
// module id = 1831
// module chunks = 0